import { PricingError } from './cartItemPrice';
import { GuestProduct } from './guestProduct';
import { ShownSteps } from './miscellaneous';

export interface UpsellItem extends GuestProduct {
  id?: string;
  parent: {
    productId: string;
    lineId: string;
    start: string;
    end: string;
  };
  configuration: {
    attachmentType: string;
    dateRestriction: DateRestriction;
    sameParentQuantity: boolean;
    isRequired: boolean;
    allowTimeAdjustment: boolean;
    inheritGuestTypes: boolean;
    uiSelectors: UiSelectors;
  };
  start?: string;
  end?: string;
  totalQuantity: number;
  error?: PricingError;
}

export interface UiSelectors {
  drawerLayout: 'singleQty' | 'oneColumn' | 'twoColumns';
  showSteps: ShownSteps;
  render: boolean;
}

export enum DateRestriction {
  PARENT_DATES = 'useParentDates',
  UNRESTRICTED = 'unrestricted',
  WITHIN_PARENT_DATES = 'selectWithinParentDates', //AWS
  CUSTOM = 'custom',
}
